<template>
  <div id="CalendarList_main">
    <div class="titleRow">
      <p class="title">
        {{ year }}
      </p>
      <div class="icon">
        <i
          id="button-1"
          class="icon-m-back"
          aria-hidden="true"
          @click="changeYear('last')"
        />
        <i
          id="button-2"
          class="icon-m-next"
          aria-hidden="true"
          @click="changeYear('next')"
        />
      </div>
    </div>
    <p class="tip">
      已安排活動事件
    </p>
    <div
      id="calendarList"
      class="calendarList"
    >
      <div
        v-for="(item, index) in newData"
        :key="index"
      >
        <div :ref="year + item.month">
          <div
            v-if="item.dataLength >= 0"
            class="month"
            :class="today.getMonth()+1 == item.month ? 'thisMonth' : ''"
            @click="goMonth(item.month)"
          >
            {{ monthTxt(item.month) }}
          </div>
          <div
            v-for="(event, key, eventIndex) in newData[index].data"
            :key="eventIndex"
          >
            <div
              v-for="(theDateEvent, theDateEventIndex) in event"
              :key="theDateEventIndex"
            >
              <div v-if="theDateEventIndex === 0">
                <div
                  class="date"
                  :class="today.getDate() == theDateEvent.date ? 'today' : ''"
                >
                  {{ theDateEvent.date }}
                </div>
                <div
                  class="week"
                  :class="today.getDate() == theDateEvent.date ? 'today' : ''"
                >
                  週{{ theDateEvent.week }}
                </div>
              </div>
              <div
                class="event"
                @click="goEvent(theDateEvent.index, item.month, theDateEvent.date)"
              >
                <div
                  class="eventDot"
                  :style="theDateEvent.color !== '' ? 'background-color:' + theDateEvent.color : 'background-color:' + presetColor[theDateEvent.colorType]"
                />
                <div class="title">
                  {{ theDateEvent.title }}
                </div>
                <div
                  v-if="theDateEvent.isAllDay"
                  class="time"
                >
                  全天
                </div>
                <div
                  v-else
                  class="time"
                >
                  {{ theDateEvent.startTime }}
                </div>
              </div>
            </div>
            <div
              v-if="item.dataLength !== eventIndex"
              class="dash"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Array,
    calendarValue: Date
  },
  data () {
    return {
      newData: [],
      today: new Date(),
      year: new Date().getFullYear(),
      waitDataProcessing: false,
      dataProcessing: false,
      presetColor: ['#29b6d8', '#51bf87', '#777777', '#f8ac59', '#ec4758', '#29b6d8'] // 預設顏色，因疑似有髒資料故加入第5個顏色，以解決ColorType=5但Color=""的情境
    }
  },
  watch: {
    data () {
      this.dataProcessing = true
      this.newData = []
      for (let month = 1; month < 13; month++) {
        this.newData.push({
          month,
          data: {},
          dataLength: -1
        })
      }
      this.data.forEach((item, index) => {
        const month = parseInt(item.CalendarTime.StartDate.substring(5, 7))
        const date = item.CalendarTime.StartDate.substring(8, 10) < 10 ? item.CalendarTime.StartDate.substring(9, 10) : item.CalendarTime.StartDate.substring(8, 10)
        // eslint-disable-next-line eqeqeq
        if (this.newData[month - 1].data[date] == undefined) {
          this.newData[month - 1].data[date] = []
          this.newData[month - 1].dataLength++
        }
        this.newData[month - 1].data[date].push({
          index,
          title: item.Title,
          isAllDay: item.CalendarTime.IsAllDay,
          startTime: item.CalendarTime.StartTime,
          week: item.CalendarTime.StartWeek,
          date,
          color: item.Color,
          colorType: item.ColorType
        })
      })
      this.waitDataProcessing = false
      this.dataProcessing = false
    },
    calendarValue () {
      this.year = this.calendarValue.getFullYear()
      const month = this.calendarValue.getMonth() + 1
      if (this.$refs[this.year + month] && this.$refs[this.year + month][0]) { document.getElementById('calendarList').scrollTop = this.$refs[this.year + month][0].offsetTop }
    },
    year () {
      this.updateOffsetTop()
    }
  },
  mounted () {
  },
  methods: {
    goMonth (month) {
      const date = new Date(this.year + '-' + ('0' + month).slice(-2) + '-' + '01')
      this.$emit('goMonth', date)
    },
    goEvent (index, month, eventDate) {
      console.log(index, month, eventDate)
      const date = new Date(this.year, month - 1, eventDate)
      console.log(date)
      this.$emit('goEvent', index, date)
    },
    changeYear (type) {
      document.getElementById('button-1').blur()
      document.getElementById('button-2').blur()
      this.$emit('changeYear', type)
    },
    updateOffsetTop () {
      console.log('手動更新')
      this.waitDataProcessing = true
      let timer = setInterval(() => {
        if (this.waitDataProcessing === false) {
          this.year = this.calendarValue.getFullYear()
          const month = this.calendarValue.getMonth() + 1
          document.getElementById('calendarList').scrollTop = this.$refs[this.year + month][0].offsetTop
          clearInterval(timer)
          timer = null
        }
      }, 100)
    },
    monthTxt (month) {
      return ['1月 January', '2月 February', '3月 March', '4月 April', '5月 May', '6月 June', '7月 July', '8月 August', '9月 September', '10月 October', '11月 November', '12月 December'][month - 1]
    }
  }
}
</script>
<style lang="sass" scoped>
#CalendarList_main
  height: 100%
  background-color: $bgDark3
  text-align: left
  padding: 24px 12px 0px
  border-radius: 8px
  box-sizing: border-box
  .titleRow
    line-height: 35px
    position: relative
    .title
      font-size: 25px
      font-weight: 600
      letter-spacing: 1px
    .icon
      position: absolute
      right: 0
      top: 0
      i
        color: $mainColor
        font-size: 18px
        line-height: 35px
        margin-left: 16px
        cursor: pointer
  .tip
    font-size: 15px
    margin: 8px 0
  .calendarList
    height: 100%
    max-height: 900px
    position: relative
    overflow: auto
    scroll-behavior: smooth
    .month
      font-size: 19px
      line-height: 32px
      cursor: pointer
      font-weight: 600
      background-color: #999
      color: $white
      padding-left: 8px
      margin: 16px 0px
      &.thisMonth
        background-color: $mainColor
    .date
      display: inline-block
      width: 28px
      height: 28px
      border-radius: 45px
      background-color: #999
      color: $white
      font-size: 18px
      line-height: 28px
      text-align: center
      font-weight: 600
      &.today
        background-color: $mainColor
    .week
      display: inline-block
      margin-left: 4px
      font-size: 17px
      line-height: 28px
      color: #999
      &.today
        color: $mainColor
    .dash
      width: 100%
      margin: 15px 0
      border-bottom: 1px dashed #999
    .event
      position: relative
      margin-top: 8px
      padding: 2px 4px
      cursor: pointer
      border-radius: 4px
      &:hover
        background-color: rgba(0, 0, 0, 0.08)
      .eventDot
        position: absolute
        top: 8px
        width: 4px
        height: 4px
        border-radius: 45px
      .title
        margin-left: 10px
        font-size: 16px
        line-height: 20px
        color: $mainFontColor
      .time
        margin-top: 2px
        font-size: 13px
        font-weight: 600
        color: #808080
        margin-left: 10px
</style>
